import { render, staticRenderFns } from "./AvailableBalance.vue?vue&type=template&id=7aa0b61a&scoped=true"
import script from "./AvailableBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvailableBalance.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AvailableBalance.vue?vue&type=style&index=0&id=7aa0b61a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0b61a",
  null
  
)

export default component.exports